import { SectionHeader } from "../../SectionHeader";
import { ModuleGrid } from "../../../layouts/ModuleGrid";
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import TiltMessage from "../../../components/feedback/TiltMessage";
import UserManagement from "../components/userManagement";




export function SettingsPage() {
    const showTiltMessage = useIsPortraitMobile();

    return (
        <div>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="Settings" />
                <ModuleGrid>
                    <div className="col-span-6 flex flex-col h-full">
                        <UserManagement />
                    </div>
                </ModuleGrid>
            </div>
        </div>
    );
}
